import { render } from "./WarehousePurchaseReceiveOld.vue?vue&type=template&id=6dc50215&scoped=true"
import script from "./WarehousePurchaseReceiveOld.vue?vue&type=script&lang=js"
export * from "./WarehousePurchaseReceiveOld.vue?vue&type=script&lang=js"

import "./WarehousePurchaseReceiveOld.vue?vue&type=style&index=0&id=6dc50215&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc50215"]])

export default __exports__